const zhCnSite: Partial<Record<string, string>> = {
  'site.meta.keywords':
    '教程, 免费游乐场, 3D 模型, 3D 编程, 3D 游戏, 创造力, 游戏, 编码, 问题解决, 设计思维, 3D models, 3D programming, 3D Games, Metaverse, Creativity, 3D, Game, Coding, Problem Solving, Design Thinking',
  'WhyBanner.creativeTitle': '基于通用的图形化编程语言',
  'WhyBanner.creativeContent':
    '我们的平台基于世界通用的青少年编程积木语言,保持了简单易用的编程界面和语法,并添加了不少提高编程效率的新功能。',
  'WhyBanner.contactTitle': '简化的三维编程语言',
  'WhyBanner.contactContent':
    '我们精心设计了一套简单易懂的三维编程积木组合,让你不再需要另外学习晦涩的编程语法和复杂的用户界面,而只需专心学习3D相关的技术。',
  'VideoBannerTop.creativeCN.title': '用图形化积木写三维程序',
};

export default zhCnSite;
